import * as React from 'react';
import AppTabs from '../../../components/AppTabs';
import { FC, useState, useCallback } from 'react';
import { Tabs, Tab } from '@material-ui/core';
import { SettingsItemContentProps } from '../SettingsItem';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';
import { GeneralSettingsData } from '../../../models/api-models';
import ServicesListSettings from './ServicesListSettings';
import PrePaymentSettings from './PrePaymentSettings';

export interface ServicesSettingsProps extends SettingsItemContentProps {
    values: GeneralSettingsData;
    onChange: (settings: GeneralSettingsData, save?: boolean) => void;
}

const ServicesSettings: FC<ServicesSettingsProps> = ({ id, values, onChange }) => {
    const t = useTranslations();
    const [tab, setTab] = useState<'servicesList' | 'prepayment'>('servicesList');

    const handleSavePrePayment = useCallback(
        prePayment => onChange({ ...values, prePayment }, true),
        [values, onChange]
    );

    return (
        <>
            <AppTabs value={tab} onChange={(_, v) => setTab(v)} indicatorColor="primary" textColor="primary" style={{ marginBottom: 'var(--spacer-S)', borderBottom: 'var(--border-thin) solid var(--appLigthGrey)' }}>
                <Tab label={t(TK.services)} value="servicesList" />
                <Tab label={t(TK.prePayment)} value="prepayment" />
            </AppTabs>

            <div>
                {tab === 'servicesList' && <ServicesListSettings
                    id={id}
                    values={values}
                    onChange={onChange}
                />}
                {tab === 'prepayment' && <PrePaymentSettings
                    id={id}
                    value={values.prePayment}
                    services={Object.fromEntries(Object.entries(values.services ?? {}).map(([id, s]) => [id, s.name ?? id]))}
                    onSave={handleSavePrePayment}
                />}
            </div>
        </>
    );
};

export default ServicesSettings;
